<script>
export default {
  name: "DidoApidocUsageFiltering",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Il est possible de filtrer les données paginées ou exportées.
    <br /><br />
    Les filtres peuvent s'appliquer soit :
    <ul>
      <li>sur des colonnes</li>
      <li>
        sur un "champ caché" lorsque les données sont adossées à certains
        référentiels ou nomenclatures
      </li>
    </ul>
    Chaque colonne ou "champ caché" peut posséder un ou plusieurs types de
    filtre.
    <br /><br />
    Enfin à chaque filtre est associée une valeur à utiliser.
    <br /><br />
    Pour filtrer selon une colonne ou un champ caché on rajoutera le paramètre
    suivant dans la requête :
    <span class="bg-black text-white q-pa-xs"
      >?{champCacheOuColonne}={typeFiltre}:{valeur}</span
    >
    <br /><br />
    On peut filtrer selon différentes colonnes et champs cachés: :
    <span class="bg-black text-white q-pa-xs"
      >?{champCache1}={typeFiltre1}:{valeur1}&{colonne2}={typeFiltre2}:{valeur2}</span
    >
    <br /><br />
    Les types de filtre qui existent dans DiDo sont les suivants :
    <ul class="filters-type-list">
      <li>
        eq : est égal à
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=eq:valeur</span>
      </li>
      <li>
        ne : est différent de
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=ne:valeur</span>
      </li>
      <li>
        contains: contient
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COLONNE1=contains:valeur</span
        >
      </li>
      <li>
        gt : est strictement plus grand que
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=gt:valeur</span>
      </li>
      <li>
        gte : est plus grand que ou égal à
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=gte:valeur</span>
      </li>
      <li>
        lt : est strictement plus petit que
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=lt:valeur</span>
      </li>
      <li>
        lte : est plus petit que ou égal à
        <br />
        la valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs">COLONNE1=lte:valeur</span>
      </li>
      <li>
        in : appartient à la liste
        <br />
        La valeur doit être une liste de chaînes alphanumériques séparés par des
        virgules
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COLONNE1=in:valeur1,valeur2,valeur3</span
        >
      </li>
      <li>
        nin : n'appartient pas à la liste
        <br />
        La valeur doit être une liste de chaînes alphanumériques séparés par des
        virgules
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COLONNE1=nin:valeur1,valeur2,valeur3</span
        >
      </li>
      <li>
        startsWith : commence par
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COLONNE1=startsWith:valeur</span
        >
      </li>
      <li>
        endsWith : finit par
        <br />
        La valeur doit être une chaîne alphanumérique
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COLONNE1=endsWith:valeur</span
        >
      </li>
      <li>
        withinCogZones : à l'intérieur d'une zone du code officiel géographique
        <br />
        La valeur doit être un identifiant de zone du référentiel du cog
        <br />
        Exemple pour le département du Puy-de-Dôme millésime 2020 :
        <span class="bg-black text-white q-pa-xs"
          >COMMUNE=withinCogZones:dpt%3A63%402020</span
        >
        <br />
        La valeur dpt:63@2020 est url-encodée
      </li>
      <li>
        withinGeometry : à l'intérieur d'une géométrie geojson
        <br />
        La valeur doit correspondre à une géométrie GeoJson valide (union de
        multi-pôlygones)
        <br />
        Exemple :
        <span class="bg-black text-white q-pa-xs"
          >COMMUNE=withinGeometry:%7B%22type%22%3A%22Polygon%22%2C%22coordinates%22%3A%5B%5B%5B2.911377%2C46.331758%5D%2C%5B3.878174%2C45.920587%5D%2C%5B3.043213%2C45.506347%5D%2C%5B2.120361%2C45.996962%5D%2C%5B2.911377%2C46.331758%5D%5D%5D%7D</span
        >
        <br />
        La valeur
        {"type":"Polygon","coordinates":[[[2.911377,46.331758],[3.878174,45.920587],[3.043213,45.506347],[2.120361,45.996962],[2.911377,46.331758]]]}
        est url-encodée
      </li>
    </ul>
    <br />
    Pour connaître l'ensemble des filtres disponibles sur un millésime, il faut
    obtenir les métadonnées du millésime avec la requête :
    <span class="bg-black text-white q-pa-xs"
      >$BASE_URL_API/datafiles/{datafileRid}?millesime={millesimeValue}</span
    >
    <br />
    Ces métadonnées contiennent :
    <ul>
      <li>
        Un champ <span class="underline-dotted">columns</span> qui contient le
        tableau des colonnes.
        <br />
        Chaque colonne possède un champ
        <span class="underline-dotted">filters</span> avec la liste des fitres
        disponibles dans la colonne.
      </li>
      <li>
        Un champ
        <span class="underline-dotted">extendedFilters</span> qui contient la
        liste des champs cachés.
        <br />
        Chaque filtre étendu possède un champ
        <span class="underline-dotted">filters</span> avec la liste des fitres
        disponibles dans ce champ caché.
      </li>
    </ul>
  </div>
</template>
